import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { useCallback, useEffect, useRef, useState } from "react";

const H2RButton = ({
	text = "",
	colour = "main",
	title = "",
	size = "large",
	icon = "",
	type = "button",
	css = "",
	onClick,
	disabled = false,
	options = [],
	optionClicked = ()=>{},
	optionsOpened = ()=>{},
	optionsClosed = ()=>{},
}) => {
	const [showContext, setShowContext] = useState(false)
	const contextRef = useRef()

	const clickOutside = useCallback((e) => {
		if (contextRef.current?.contains(e.target)) return
		setShowContext(false)
	}, [contextRef])

	useEffect(() => {
		if(options && showContext) {
			window.addEventListener('click', clickOutside)
			optionsOpened()
			console.log('options opened')
		}

		return () => {
			window.removeEventListener('click', clickOutside)
			optionsClosed()
		}
	}, [clickOutside, options, showContext, contextRef, optionsOpened, optionsClosed])

	// switch (icon) {
	// 	case "cog":
	// 		iconBefore = (
	// 			<path
	// 				fillRule="evenodd"
	// 				clipRule="evenodd"
	// 				d="M9.192 2.536c-.304-1.248-2.08-1.248-2.384 0a1.226 1.226 0 01-1.829.759c-1.098-.67-2.353.587-1.685 1.684a1.227 1.227 0 01-.757 1.83c-1.25.303-1.25 2.08 0 2.382a1.226 1.226 0 01.757 1.83c-.668 1.097.587 2.353 1.685 1.685a1.225 1.225 0 011.83.757c.303 1.25 2.08 1.25 2.382 0a1.226 1.226 0 011.83-.757c1.097.668 2.353-.588 1.684-1.685a1.226 1.226 0 01.758-1.83c1.249-.303 1.249-2.08 0-2.382a1.225 1.225 0 01-.757-1.83c.668-1.097-.588-2.353-1.685-1.684a1.226 1.226 0 01-1.83-.758zM8 10.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z"
	// 			/>
	// 		);
	// 		break;

	// 	case "multiview":
	// 		iconBefore = (
	// 			<path
	// 				fillRule="evenodd"
	// 				clipRule="evenodd"
	// 				d="M4 3.2a2.4 2.4 0 00-2.4 2.4v4.8A2.4 2.4 0 004 12.8h8a2.4 2.4 0 002.4-2.4V5.6A2.4 2.4 0 0012 3.2H4zm-.8 7.2v-.8h4v1.6H4a.8.8 0 01-.8-.8zm5.6.8H12a.8.8 0 00.8-.8v-.8h-4v1.6zm0-3.2h4V5h-4v3zM7.2 5h-4v3h4V5z"
	// 				fill="currentColor"
	// 			/>
	// 		);
	// 		break;

	// 	case "pencil":
	// 		iconBefore = (
	// 			<path
	// 				d="M10.869 2.869A1.6 1.6 0 1113.13 5.13l-.634.635-2.263-2.263.635-.634zM9.103 4.634L2.4 11.338V13.6h2.262l6.704-6.703-2.264-2.263h.001z"
	// 				fill="currentColor"
	// 			/>
	// 		);
	// 		break;

	// 	case "tick":
	// 		iconBefore = (
	// 			<path
	// 				fillRule="evenodd"
	// 				clipRule="evenodd"
	// 				d="M13.366 4.234a.8.8 0 010 1.132l-6.4 6.4a.8.8 0 01-1.132 0l-3.2-3.2a.8.8 0 011.132-1.132L6.4 10.07l5.835-5.835a.8.8 0 011.13 0z"
	// 				fill="currentColor"
	// 			/>
	// 		);
	// 		break;

	// 	case "locked":
	// 		iconBefore = (
	// 			<path
	// 				d="M8 10v1.333V10zm-4 4h8a1.334 1.334 0 001.333-1.333v-4A1.334 1.334 0 0012 7.333H4a1.333 1.333 0 00-1.333 1.334v4A1.333 1.333 0 004 14zm6.667-6.667V4.667a2.667 2.667 0 10-5.334 0v2.666h5.334z"
	// 				stroke="currentColor"
	// 				fill="none"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "unlocked":
	// 		iconBefore = (
	// 			<path
	// 				d="M5.333 7.333V4.667A2.667 2.667 0 019.886 2.78M8 10v1.333M4 14h8a1.334 1.334 0 001.333-1.333v-4A1.334 1.334 0 0012 7.333H4a1.333 1.333 0 00-1.333 1.334v4A1.333 1.333 0 004 14z"
	// 				stroke="currentColor"
	// 				fill="none"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "plus":
	// 		iconBefore = (
	// 			<path
	// 				d="M8 8H4m4-4v4-4zm0 4v4-4zm0 0h4-4z"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "minus":
	// 		iconBefore = (
	// 			<path
	// 				d="M13.333 8H2.667"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "x":
	// 		iconBefore = (
	// 			<path
	// 				d="M4 4l8 8m-8 0l8-8-8 8z"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "desktop":
	// 		iconBefore = (
	// 			<path
	// 				d="M6.5 11.333l-.5 2-.667.667h5.334L10 13.333l-.5-2h-3zm-3.167 0h9.334A1.333 1.333 0 0014 10V3.333A1.334 1.334 0 0012.667 2H3.333A1.333 1.333 0 002 3.333V10a1.333 1.333 0 001.333 1.333z"
	// 				stroke="currentColor"
	// 				fill="none"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "external":
	// 		iconBefore = (
	// 			<path
	// 				d="M6.667 4H4a1.333 1.333 0 00-1.333 1.333V12A1.333 1.333 0 004 13.333h6.667A1.334 1.334 0 0012 12V9.333M9.333 2.667h4m0 0v4m0-4L6.667 9.333"
	// 				stroke="currentColor"
	// 				fill="none"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "double_arrow_right":
	// 		iconBefore = (
	// 			<path
	// 				d="M8.667 3.333L13.333 8l-4.666 4.667M3.333 3.333L8 8l-4.667 4.667"
	// 				stroke="currentColor"
	// 				fill="none"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "refresh":
	// 		iconBefore = (
	// 			<path
	// 				d="M3.055 6h-.388V2.667L3.055 6zm0 0a5.334 5.334 0 0110.237 1.333M3.055 6H6m6.946 4h.387v3.333L12.946 10zm0 0A5.336 5.336 0 012.708 8.667M12.946 10H10"
	// 				stroke="currentColor"
	// 				fill="none"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "download":
	// 		iconBefore = (
	// 			<path
	// 				d="M2.667 10.666v.667a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2v-.667M10.667 8 8 10.666m0 0L5.333 8M8 10.666v-8"
	// 				stroke="currentColor"
	// 				fill="none"
	// 				strokeWidth="1.5"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "pause":
	// 		iconBefore = (
	// 			<path
	// 				d="M6 5v6m4-6v6"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "play":
	// 		iconBefore = (
	// 			<path
	// 				d="M12.825 7.804 7.981 4.742a1.584 1.584 0 0 0-1.557-.071 1.484 1.484 0 0 0-.585.53 1.38 1.38 0 0 0-.214.739v6.123c0 .26.074.516.215.739.141.223.344.405.585.528a1.584 1.584 0 0 0 1.556-.072l4.844-3.062c.208-.131.378-.309.496-.518a1.377 1.377 0 0 0 0-1.355 1.467 1.467 0 0 0-.496-.517v-.002Z"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "sync-up":
	// 		iconBefore = (
	// 			<path
	// 				d="M4.667 10.666a2.666 2.666 0 0 1-.587-5.268A3.334 3.334 0 1 1 10.6 4h.067a3.334 3.334 0 0 1 .666 6.6M10 8.667l-2-2m0 0-2 2m2-2v8"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 				fill="none"
	// 			/>
	// 		);
	// 		break;

	// 	case "sync-down":
	// 		iconBefore = (
	// 			<path
	// 				d="M4.667 10.666a2.666 2.666 0 0 1-.587-5.268A3.334 3.334 0 1 1 10.6 4h.067a3.334 3.334 0 0 1 .666 6.6M6 12.666l2 2m0 0 2-2m-2 2v-8"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 				fill="none"
	// 			/>
	// 		);
	// 		break;

	// 	case "chevron-left":
	// 		iconBefore = (
	// 			<path
	// 				d="M10 12.667 5.333 8 10 3.333"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "chevron-down":
	// 		iconBefore = (
	// 			<path
	// 				d="M12.667 6 8 10.666 3.333 6"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "clipboard":
	// 		iconBefore = (
	// 			<path
	// 				d="M6 3.333H4.667a1.333 1.333 0 0 0-1.334 1.334v8A1.333 1.333 0 0 0 4.667 14h6.666a1.334 1.334 0 0 0 1.334-1.333v-8a1.334 1.334 0 0 0-1.334-1.334H10m-4 0a1.333 1.333 0 0 0 1.333 1.334h1.334A1.333 1.333 0 0 0 10 3.333m-4 0A1.333 1.333 0 0 1 7.333 2h1.334A1.333 1.333 0 0 1 10 3.333"
	// 				stroke="currentColor"
	// 				fill="none"
	// 				strokeWidth="2"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "volume":
	// 		iconBefore = (
	// 			<path
	// 				d="M10.357 5.643a3.331 3.331 0 0 1 0 4.715m1.886-6.6a6 6 0 0 1 0 8.485M3.724 10H2.667A.667.667 0 0 1 2 9.334V6.667A.667.667 0 0 1 2.667 6h1.057l3.138-3.138A.667.667 0 0 1 8 3.333v9.334a.667.667 0 0 1-1.138.471L3.724 10Z"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				fill="none"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "muted":
	// 		iconBefore = (
	// 			<path
	// 				d="M3.724 10H2.667A.667.667 0 0 1 2 9.334V6.667A.667.667 0 0 1 2.667 6h1.057l3.138-3.138A.667.667 0 0 1 8 3.333v9.334a.667.667 0 0 1-1.138.471L3.724 10ZM12.667 8 14 9.333m-2.667 0L12.667 8l-1.334 1.333ZM12.667 8 14 6.667 12.667 8Zm0 0-1.334-1.333L12.667 8Z"
	// 				stroke="currentColor"
	// 				strokeWidth="2"
	// 				fill="none"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "arrows-pointing-out":
	// 		iconBefore = (
	// 			<path
	// 				d="M2.5 2.5V5.5M2.5 2.5H5.5M2.5 2.5L6 6M2.5 13.5V10.5M2.5 13.5H5.5M2.5 13.5L6 10M13.5 2.5H10.5M13.5 2.5V5.5M13.5 2.5L10 6M13.5 13.5H10.5M13.5 13.5V10.5M13.5 13.5L10 10"
	// 				stroke="currentColor"
	// 				strokeWidth="1.5"
	// 				fill="none"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "arrows-pointing-in":
	// 		iconBefore = (
	// 			<path
	// 				d="M6 6V3M6 6H3M6 6L2.5 2.5M6 10V13M6 10H3M6 10L2.5 13.5M10 6H13M10 6V3M10 6L13.5 2.5M10 10H13M10 10V13M10 10L13.5 13.5"
	// 				stroke="currentColor"
	// 				strokeWidth="1.5"
	// 				fill="none"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		);
	// 		break;

	// 	case "minus-1-min":
	// 		iconBefore = (
	// 			<path
	// 				fill="currentColor"
	// 				d="M4.256 7.034v.84H1.934v-.84h2.322ZM7.363 4.91V10H6.287V5.93h-.03l-1.166.732v-.955l1.26-.798h1.012ZM8.583 10V6.182h1.01v.673h.044c.08-.223.212-.4.398-.529.185-.13.408-.194.666-.194.262 0 .485.066.669.196.184.13.306.305.368.527h.04c.077-.218.218-.393.422-.524.206-.133.448-.199.728-.199.357 0 .646.114.868.34.224.226.336.546.336.96V10h-1.057V7.641c0-.212-.056-.371-.169-.477a.593.593 0 0 0-.423-.16.567.567 0 0 0-.45.185.695.695 0 0 0-.161.48V10h-1.027V7.619a.615.615 0 0 0-.161-.448.554.554 0 0 0-.42-.166.583.583 0 0 0-.319.09.615.615 0 0 0-.22.245.782.782 0 0 0-.083.368V10H8.583Z"
	// 			/>
	// 		);
	// 		break;

	// 	default:
	// 		iconBefore = "";
	// }
	return (
		<div className="flex relative">
			<button
				onClick={onClick}
				disabled={disabled}
				title={title}
				className={` w-full sm:w-auto flex justify-center items-center leading-none font-semibold tracking-wide text-gray-100 rounded transition duration-300 ease-in-out focus:outline-none focus:ring disabled:pointer-events-none
							${size === "small" ? "text-sm px-2 py-2" : "text-lg px-4 py-2"}
				
							${
								colour === "main" &&
								type === "button" &&
								"bg-main-500 hover:bg-main-400 focus:ring-main-500"
							}
												${
													colour === "dark" &&
													type === "button" &&
													"bg-gray-700 hover:bg-gray-600 focus:ring-main-500"
												}

													${
														colour === "main" &&
														type === "link" &&
														"inline-flex text-main-400 border-b border-transparent bg-transparent hover:text-main-300 focus:ring-main-400"
													}

													${
														colour === "dark" &&
														type === "link" &&
														"inline-flex text-sm text-gray-600 border-b border-transparent bg-transparent hover:text-gray-500 focus:ring-gray-500"
													}
													${
														colour === "light" &&
														type === "link" &&
														"hover:bg-gray-800"
													}
							${disabled && "opacity-25 cursor-auto"}
							${css}

		`}
			>
				{icon ? <FontAwesomeIcon icon={icon} /> : ''}
				{text !== "" && <span className={icon && 'ml-1'}>{text}</span>}
			</button>
			{options.length ? 
			<>
				<button onClick={()=>setShowContext(!showContext)} className="flex items-center justify-center px-1 hover:bg-gray-800 rounded">
					<FontAwesomeIcon icon={faChevronDown} size="sm" />
				</button>

					{showContext && 
						<div
							className="absolute right-4 flex flex-col bg-gray-800 z-10 border border-gray-900 rounded"
							ref={contextRef}
						>
							{options.map((option)=>{
								const {label, value} = option
								return (
									<button
										key={value}
										onClick={()=> {
											optionClicked(value)
											setShowContext(false)
										}}
										disabled={option.disabled}
										className="px-2 text-left hover:bg-gray-700 whitespace-nowrap disabled:pointer-events-none disabled:text-gray-500"
									>
										{label}
									</button>
								)
							})}
					</div>
				}
					</>
			: ''
			}
		</div>
	);
};

H2RButton.propTypes = {
	text: PropTypes.string,
	colour: PropTypes.string,
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	type: PropTypes.string,
	css: PropTypes.string,
	onClick: PropTypes.func.isRequired,
};

export default H2RButton;
